/**
 * Payload for the create/copy pre-dialog.
 *
 * Includes `category__` when the form has one, plus every key declared by
 * the template for the category currently selected. Keys the user left
 * untouched are sent as null so JSON.stringify does not drop them
 * (LAX-10101). Values that belong to a previously selected category are
 * left out (LAX-10275).
 */
export function buildPriorItemSubmission(
    values: Record<string, unknown>,
    template: { [key: string]: unknown } | null | undefined,
): Record<string, unknown> {
    const submitted: Record<string, unknown> = {};
    if (Object.prototype.hasOwnProperty.call(values, 'category__')) {
        submitted.category__ = values.category__;
    }
    for (const key of Object.keys(template || {})) {
        const value = values[key];
        submitted[key] = value === undefined ? null : value;
    }
    return submitted;
}
